import Wall from './Wall';
export default Wall;